import styled from "styled-components";
import { Colors, FInter, FlexBox } from "@brg/ui";
import { CheckBoxProps } from "@brg/input/dist/checkbox/InputCheckbox";
import { LayoutConst } from "../../../core";
import { ProjectEditPageGridLabel } from "../../pages/projectEdit/styles";

export const CheckBoxWrapper = styled(FlexBox)<{ disabled: boolean }>`
  align-items: center;
  position: relative;
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
  user-select: none;
  width: 100%;
`;

export const RadioBox = styled.div<{ isBook?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: ${p => p.isBook ? "column" : "row"};
  width: 100%;
  ${ProjectEditPageGridLabel} {
        width: 100%;
        padding: 0;
        margin: 0;
  }    
`

export const RadioCircle = styled(FlexBox)<CheckBoxProps & { clr?: string }>`
  width: 24px;
  height: 24px;
  // background: #FEFEFE;
  background: transparent;
  border: 1px solid ${p => p.clr ? p.clr : '#B6B6B5'};
  box-sizing: border-box;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;


  svg {
    opacity: 0;
    transition: all 0.2s;
  }

  opacity: ${p => p.disabled ? 0.31 : 1};
`;

export const RadioLabel = styled(FInter.SmallTextBold)<{ clr?: string }>`
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.projectEdit.label};
  @media(min-width: 1920px) {
    //font-size: 13px;
    //line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: normal;
  }
`

export const RadioInputSource = styled.input`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 100%;
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
  opacity: 0;

  &:checked {
    & ~ ${RadioBox} {

      ${RadioCircle} {
        border: 1px solid ${Colors.galBlack47};
        :after {
          content: "" !important;
          width: 5px !important;
          height: 5px !important;
          border-radius: 50% !important;
          background: ${({ theme }) => theme.projectEdit.label} !important;
        }
      }

      ${RadioLabel} {
        color: #545453;
      }
    }
`;

import styled from "styled-components";
import { Colors, FInter, FlexBox } from "@brg/ui";
import { CheckBoxProps } from "@brg/input/dist/checkbox/InputCheckbox";
import { LayoutConst } from "../../../core";
import { ProjectEditPageGridLabel } from "../../pages/projectEdit/styles";

export const CheckBoxWrapper = styled(FlexBox)<{ disabled: boolean }>`
  align-items: center;
  position: relative;
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
  user-select: none;
  width: 100%;
`;

export const RadioBox = styled.div<{ isBook?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: ${p => p.isBook ? "column" : "row"};
  width: 100%;
  ${ProjectEditPageGridLabel} {
        width: 100%;
        padding: 0;
        margin: 0;
  }    
`

export const RadioCircle = styled(FlexBox)<CheckBoxProps & { clr?: string }>`
  width: 24px;
  height: 24px;
  // background: #FEFEFE;
  background: transparent;
  border: 1px solid ${p => p.clr ? p.clr : '#B6B6B5'};
  box-sizing: border-box;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;


  svg {
    opacity: 0;
    transition: all 0.2s;
  }

  opacity: ${p => p.disabled ? 0.31 : 1};
`;

export const RadioLabel = styled(FInter.SmallTextBold)<{ clr?: string }>`
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.projectEdit.label};
  @media(min-width: 1920px) {
    //font-size: 13px;
    //line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: normal;
  }
`

export const RadioInputSource = styled.input`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 100%;
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
  opacity: 0;

  &:checked {
    & ~ ${RadioBox} {

      ${RadioCircle} {
        border: 1px solid ${Colors.galBlack47};
        :after {
          content: "" !important;
          width: 5px !important;
          height: 5px !important;
          border-radius: 50% !important;
          background: ${({ theme }) => theme.projectEdit.label} !important;
        }
      }

      ${RadioLabel} {
        color: #545453;
      }
    }
`;

